import React from 'react';
import { Link } from 'gatsby';
import { Link as ChakraLink } from '@chakra-ui/react';

function LinkWrapper({ href, children, ...props }) {
  return href?.startsWith('http') ? (
    <ChakraLink 
      href={href} {...props} 
      textDecoration="none" 
      _hover={{textDecoration:'none'}} 
      target="_blank" 
      rel="noopener noreferrer"
    >
      {children}
    </ChakraLink>
  ) : (
    <Link to={href} {...props}>
      {children}
    </Link>
  );
}

export default LinkWrapper;
